import { MenubarMobileRightDrawer } from '../../../areas/Menubar/Mobile/MobileRight/MenubarMobileRightDrawer';
import { MenubarMobilePathDrawer } from '../../../areas/Menubar/Mobile/MobilePath/MenubarMobilePathDrawer';
export class MobileLazyComponents {
    MenubarMobileRightDrawer = MenubarMobileRightDrawer;
    MenubarMobilePathDrawer = MenubarMobilePathDrawer;
}
